import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AuthenticationService } from './../../services/authentication.service'
import { IPublicReportByTokenDto } from './dto/public-report-by-token.dto'

@Component({
	selector: 'app-validation-report',
	templateUrl: './validation-report.component.html'
})

export class ValidationReportComponent implements OnInit {
	constructor(
		private authenticationService: AuthenticationService,
		private activatedRoute: ActivatedRoute) { }

	public alreadyValidated: boolean = false
	public isValidToken: boolean = false
	public blockedRequestThrottler: boolean = false
	public isCommunicationReport: boolean = false
	public communicationData: IPublicReportByTokenDto

	public isLoading: boolean = false

	public ngOnInit() {
		this.validateToken()
	}

	public initMap(latitude: number, longitude: number) {
		if (!latitude || !longitude) {
			console.log('latitude or longitude is missing')
			return
		}

		const mapView = document.getElementById('map-validation-report')

		const position = new google.maps.LatLng(
			latitude,
			longitude
		)

		const map: google.maps.Map = new google.maps.Map(mapView, {
			zoom: 14,
			center: position,
			streetViewControl: false,
			gestureHandling: 'none'
		})

		map.setOptions({
			styles: [
				{
					featureType: 'poi',
					stylers: [
						{ visibility: 'off' }
					]
				},
				{
					featureType: 'transit.station.bus',
					stylers: [
						{ visibility: 'off' }
					]
				}
			]
		})

		new google.maps.Marker({
			position,
			map,
			animation: google.maps.Animation.DROP
		})
	}

public validateToken() {
	this.activatedRoute.queryParams.subscribe(params => {
		const token = params.token

		// communication | evaluation-report-arboreal | inventory-report-arboreal
		// schedule-operation-report-arboreal | operation-report-arboreal |
		// schedule-planting-report-arboreal | planting-report-arboreal
		const type = params.type

		this.isLoading = true
		this.authenticationService.validateReportToken(token, type).subscribe((result: IPublicReportByTokenDto) => {
			this.isValidToken = true
			this.alreadyValidated = true
			this.isLoading = false

			console.log('result', result)
			if (result) {
				this.isCommunicationReport = true
				this.communicationData = result

				setTimeout(() => {
					this.initMap(result.addressCoordinatesLat, result.addressCoordinatesLng)
				}, 1000)
			}
		}, error => {
			this.isLoading = false

			if (error.status == 429) {
				this.blockedRequestThrottler = true
				return
			}

			this.isValidToken = false
			this.alreadyValidated = true
		})
	})
}
}
